export default function subscribeToOneApp(cb) {
  window.addEventListener('message', event => {
    try {
      cb(JSON.parse(event.data));
    } catch (e) {}
  });
}
